(function($, window, document, undefined) {
	$(document).ready(function() {
		$(".js-gallery").each(function() {
			var $gallery = $(this);
			var $items = $gallery.find("[data-gallery-item]");
			var $thumbnails = $gallery.find("[data-gallery-thumb]");

			$items.slice(1).hide();
			$thumbnails.eq(0).attr("data-gallery-active", true);

			$thumbnails.click(function() {
				var $thumb = $(this);

				if (!$thumb.attr("data-gallery-active")) {
					var index = $thumbnails.index($thumb);

					$items.hide();
					$items.eq(index).show();

					$thumbnails.removeAttr("data-gallery-active");
					$thumb.attr("data-gallery-active", true);
				}
			});
		});
	});
})(jQuery, window, document);
